import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { StoreData } from "../../types";
import { getAssociatedStoresByAppId } from "../../resources/apps/getAssociatedStoresByAppId";
import { Tabs } from "../../components/Tabs";
import { AppPageListBeta } from "./AppPageListBeta";
import { AppPageListEnvironment } from "./AppPageListEnvironments";
import { AppPageListVersion } from "./AppPageListVersion";
import { AppPageEmptyApp } from "./AppPageEmptyApp";

export const AppPageTabsStore = () => {
  const [storeData, setStoreData] = useState<StoreData[] | null>(null);
  const { appId } = useParams();

  useEffect(() => {
    async function getData() {
      try {
        if (typeof appId !== "string") {
          console.error('Error: URL parameter "appId" is not a string.');
          return;
        }

        const versions = await getAssociatedStoresByAppId(appId);
        setStoreData(versions.body);
      } catch (error) {
        console.error("getAppData: ", error);
      }
    }

    void getData();
  }, [appId]);

  return (
    <>
      {storeData !== null && storeData.length ? (
        <Tabs
          data={storeData.map((current) => ({
            label: current.name,
            element: (
              <div className="app-page__grid">
                <AppPageListVersion {...{ appId }} storeId={current.id} />
                <div className="app-page__sub-versions">
                  <AppPageListEnvironment {...{ appId }} storeId={current.id} />
                  <AppPageListBeta {...{ appId }} storeId={current.id} />
                </div>
              </div>
            ),
          }))}
        />
      ) : (
        <AppPageEmptyApp />
      )}
    </>
  );
};
